import { KeyboardArrowDown } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'

type ViewOlderMentionsProps = {
  onClick: () => void
  translate: (key: string) => string
}

export const ViewOlderMentions = ({ onClick, translate }: ViewOlderMentionsProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
      sx={{ py: 2, cursor: 'pointer' }}
    >
      <Typography variant="Body12pxRegular" color="neutralLight.900">
        {translate('mentions.view-older')}
      </Typography>
      <KeyboardArrowDown sx={{ color: 'neutralLight.900', fontSize: 16 }} />
    </Stack>
  )
}
